import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../plugins/https";
import { setGallery, getGallery, deleteGallery, updateGallery } from "./action";
import {
  DELETE_GALLERY,
  GET_GALLERY,
  SET_GALLERY,
  UPDATE_GALLERY,
} from "./actionType";

export const addGallery = (Gallery) => async (dispatch) => {
  try {
    const res = await PostRequest("/gallery", Gallery);
    dispatch(setGallery(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const getGalleryData = async (dispatch) => {
  try {
    const res = await GetRequest("/gallery");
    dispatch(getGallery(res.data));
  } catch (error) {
    console.error("Error getting gallery: ", error);
  }
};

export const deleteGalleryData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/gallery/${id}`);
    dispatch(deleteGallery(id)); // Pass only the ID to filter it out in the reducer
  } catch (error) {
    console.error("Error in deleting gallery: ", error);
  }
};

export const updateGalleryData =
  (id, updatedGalleryData) => async (dispatch) => {
    try {
      const res = await PutRequest(`/gallery/${id}`, updatedGalleryData); // Send the updated data
      dispatch(updateGallery(res.data)); // Assuming the updated data is returned
      getGalleryData(dispatch);
    } catch (error) {
      console.error("Error in updating gallery: ", error);
    }
  };

const initialState = {
  gallery: "",
  galleryData: [],
};

export const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GALLERY:
      return {
        ...state,
        gallery: action.payload,
      };
    case GET_GALLERY:
      return {
        ...state,
        galleryData: action.payload,
      };
    case DELETE_GALLERY:
      return {
        ...state,
        galleryData: state.galleryData.filter(
          (item) => item.id !== action.payload
        ),
      };
    case UPDATE_GALLERY:
      return {
        ...state,
        galleryData: state.galleryData.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        ), // Update the specific item
      };
    default:
      return state;
  }
};
